import { BranchesOutlined } from '@ant-design/icons';
import { ApplicationMenu } from '@icon-park/react';
import { Button, Popover, Result } from 'antd';
import React from 'react';
import { useStyles } from "./Sitemap.style";
export var SuperHeaderSitemap = function SuperHeaderSitemap() {
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Popover, {
    placement: "bottomRight",
    trigger: "click",
    content: /*#__PURE__*/React.createElement(Result, {
      icon: /*#__PURE__*/React.createElement(BranchesOutlined, null),
      title: "\u6B63\u5728\u5F00\u53D1\u4E2D",
      subTitle: "\u672C\u529F\u80FD\u6B63\u5728\u5F00\u53D1\u4E2D\uFF0C\u656C\u8BF7\u671F\u5F85"
    })
  }, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(ApplicationMenu, {
      theme: "outline"
    }),
    type: "text"
  })));
};